import http from '@/biz/http.mjs'

export default {

    create: (data) => http.post('/archdbs', data),

    publish: (data) => http.put(
        '/archdbs/rlsandrevise',
        {...data, stsCode: 'RLS'}
    ),

    pull: ({pkid}) => http.get(`/archdbs/${pkid}/dps`),
    push: (data) => http.post('/archdbs/batchmodify', data),
    read: ({pkid}) => http.get(`/archdbs/${pkid}`),
    readList: (args) => http.get('/archdbs', args),

    revise: ({pkid}) => http.put(
        '/archdbs/rlsandrevise',
        {pkid, stsCode: 'REVISE'}
    ),

    update: (data) => http.put(`/archdbs/${data.pkid}`, data),
    updateMap: (data) => http.put(`/archdbs/${data.pkid}/map`, data),
}
